import React from 'react';
import moment from 'moment';

import 'moment/locale/es';

const LANGUAGE_LOCAL_STORAGE_KEY = 'language';
const enLanguage = 'en';
const esLanguage = 'es';
const languages = [enLanguage, esLanguage];
const defaultLanguage = navigator.languages.find((lang) => languages.includes(lang)) ?? enLanguage;
const storedLanguageValue = localStorage.getItem(LANGUAGE_LOCAL_STORAGE_KEY) ?? defaultLanguage;
const LanguageContext = React.createContext<any>({});
const useLanguage = () => React.useContext(LanguageContext);

localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, storedLanguageValue);
moment.locale(storedLanguageValue);

type Props = {
  children?: React.ReactNode | JSX.Element;
};

const LanguageContextProvider = (props: Props) => {
  const [language, setLanguage] = React.useState(storedLanguageValue);

  const updateLanguage = (newLanguage) => {
    localStorage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, newLanguage);
    moment.locale(newLanguage);
    setLanguage(newLanguage);
  };

  const contextValue = { language, updateLanguage };

  return <LanguageContext.Provider value={contextValue}>{props.children}</LanguageContext.Provider>;
};

const withLanguage = (Component: React.ComponentType): React.ComponentType => {
  const WithLanguage = (props) => (
    <LanguageContext.Consumer>
      {({ language, updateLanguage }: any) => (
        <Component {...props} language={language} updateLanguage={updateLanguage} />
      )}
    </LanguageContext.Consumer>
  );

  return WithLanguage;
};

export {
  enLanguage,
  esLanguage,
  defaultLanguage,
  languages,
  LanguageContext,
  useLanguage,
  LanguageContextProvider,
  withLanguage,
};

export default LanguageContext;
